const initialState = {
  pricesList: [],
};

export const pricesReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "prices")
    return action.execute(state);
  return state;
};
